import { createOidcAuth, LogLevel, SignInType } from 'vue-oidc-client/vue3'

let mainOidc = null

if (window.auth) {

    if (process.env.VUE_APP_SSO_URL != undefined) {
        window.auth.authority = process.env.VUE_APP_SSO_URL;
        window.auth.metadata = {
            issuer: process.env.VUE_APP_SSO_URL,
            authorization_endpoint: `${process.env.VUE_APP_SSO_URL}/OAUTH2/authserver.php`,
            token_endpoint: `${process.env.VUE_APP_SSO_URL}/OAUTH2/authserver.php`,
            userinfo_endpoint:
                `${process.env.VUE_APP_SSO_URL}/api/adas/openidconnect/userinfo`,
            jwks_uri: `${process.env.VUE_APP_SSO_URL}/OIDC/.well-known/jwks.json`,
            end_session_endpoint: `${process.env.VUE_APP_SSO_URL}/status/`,
            /*issuer: `${process.env.VUE_APP_SSO_URL}/realms/upc`,
            authorization_endpoint: `${process.env.VUE_APP_SSO_URL}/realms/upc/protocol/openid-connect/auth`,
            token_endpoint: `${process.env.VUE_APP_SSO_URL}/realms/upc/protocol/openid-connect/token`,
            userinfo_endpoint:
                `${process.env.VUE_APP_SSO_URL}/realms/upc/protocol/openid-connect/userinfo`,
            jwks_uri: `${process.env.VUE_APP_SSO_URL}/realms/upc/protocol/openid-connect/certs`,
            end_session_endpoint: `${process.env.VUE_APP_SSO_URL}/realms/upc/protocol/openid-connect/logout`,*/
        };
    }
    if (process.env.VUE_APP_SSO_CLIENT_ID != undefined) {
        window.auth.client_id = process.env.VUE_APP_SSO_CLIENT_ID;
        window.auth.scope = `openid profile email api ${process.env.VUE_APP_SSO_CLIENT_ID}`;
        //window.auth.scope = `openid profile email`;
    }

/*const authority = "https://login.pre.upc.edu/realms/upc"


const auth = {
    authority: authority,
    clientId: client_id,
    redirectUri: `${window.location.origin}/oidc-callback`,
    automaticSilentRenew: true,
    automaticSilentSignin: true,
    responseType: "code",
    scope: `openid profile email`,
    loadUserInfo: true,
    metadataSeed: {
        end_session_endpoint: `${authority}/status/`
    },
}*/



    const loco = window.location
    const appRootUrl = `${loco.protocol}//${loco.host}${process.env.BASE_URL}`;
    mainOidc = createOidcAuth(
        'main',
        SignInType.Window,
        appRootUrl,
        window.auth,
        console,
        LogLevel.Error
    )
}

export default mainOidc
